<template>
	<modal :exibir="exibir" :titulo="titulo" :max-width="500" @close="$emit('fechar-modal')">
		<template #body>
			<v-list>
				<v-list-item v-for="signatario in signatarios" :key="signatario.email">
					<v-icon size="18" class="mr-2" :color="corIconeSituacaoSignatario(signatario.situacao)">
						{{ iconeSituacaoSignatario(signatario.situacao) }}
					</v-icon>
					<v-list-item-content> {{ signatario.email }}</v-list-item-content>
				</v-list-item>
			</v-list>
		</template>
	</modal>
</template>

<script>
import { situacaoSignatarioDocumentoProcessoDigital } from '@/core/constants'

export default {
	name: 'modal-assinatura-signatario',
	props: {
		exibir: {
			type: Boolean,
			required: true,
		},
		corSituacaoAssinado: {
			type: String,
			default: 'success',
		},
		corSituacaoNaoAssinado: {
			type: String,
			default: 'warning',
		},
		signatarios: {
			type: Array,
			required: true,
		},
		titulo: {
			type: String,
			default: '',
		},
	},
	methods: {
		iconeSituacaoSignatario(situacao) {
			switch (situacao) {
				case situacaoSignatarioDocumentoProcessoDigital.ASSINADO.value:
					return 'mdi-check'
				case situacaoSignatarioDocumentoProcessoDigital.EXPIRADO.value:
					return 'mdi-timer-off'
				default:
					return 'mdi-clock-outline'
			}
		},
		corIconeSituacaoSignatario(situacao) {
			return situacao === situacaoSignatarioDocumentoProcessoDigital.ASSINADO.value
				? this.corSituacaoAssinado
				: this.corSituacaoNaoAssinado
		},
	},
}
</script>
